<template>
  <div class="app-container">
    <div class="games-container">
      <div class="game-list-container">
        <div class="games-title">會員注冊</div>
        <div class="game-form">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="電郵地址" prop="email">
                  <el-row>
                    <el-col :span="15"><el-input v-model="ruleForm.email" placeholder="請輸入閣下常用的電郵地址" /></el-col>
                    <el-col :span="1">@</el-col>
                    <el-col :span="8">
                      <el-select v-model="value" placeholder="請選擇郵箱後綴">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>                           
                </el-form-item>
                    <el-form-item label="電郵校驗" prop="code">
                      <el-row>
                        <el-col :span="8"><el-input v-model="ruleForm.code" placeholder="郵箱校驗碼" /></el-col>
                        <el-col :span="7"><span style="margin-right:10px"></span></el-col>
                        <el-col :span="1">
                          <el-button type="warning" :disabled="codeDelay" @click="getCode" style="margin-left:10px">獲取電郵校驗碼<span v-if="codeDelay">({{ long }})</span></el-button>
                        </el-col>
                      </el-row>  
                </el-form-item>
                <el-form-item label="會員賬號" prop="uid">
                    <el-input type="text" v-model="ruleForm.uid" autocomplete="off" placeholder="會員賬號由字母和數字組成" />
                </el-form-item>
                <el-form-item label="登入密碼" prop="pass">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="會員密碼由字母、數字或英文符號組成" />
                </el-form-item>
                <el-form-item label="確認密碼" prop="checkPass">
                    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"  placeholder="會員密碼由字母、數字或英文符號組成" />
                </el-form-item>
                <el-form-item prop="agree">
                    <el-checkbox checked>同意接受 <a href="/policy">《會員服務條款》</a> .<a href="/policy">《個人隱私條款》</a></el-checkbox>
                </el-form-item>
                <el-form-item style="text-align:center">
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
  export default {
    data() {
        var validateemail = (rule, value, callback) => {
         const reg = /^[a-zA-Z0-9]{4,16}$/
        if (!reg.test(value)) {
            callback(new Error('電郵地址必須由字母或數字組合,請輸入4-16位字符'))
        } else {
            callback();
        }
      };
      var validatecode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('請輸入電郵校驗碼'));
        } else {
          callback();
        }
      };
      var validateuid = (rule, value, callback) => {
         const reg = /^[a-zA-Z0-9]{4,16}$/
        if (!reg.test(value)) {
            callback(new Error('登入賬號必須由字母或數字組合,請輸入4-16位字符'))
        } 
        else {
          callback();
        }
      };

      var validatePass = (rule, value, callback) => {
        var reg = /^[a-zA-Z0-9]{6,16}$/    
        if (!reg.test(value)) {
            callback(new Error('密碼由數字、字母組合,請輸入6-16位字符'))
        } 
        else {
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('請再次輸入登入密碼'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('兩次輸入的密碼不一致!'));
        } else {
          callback();
        }
      };
      return {
        codeDelay: false,
        long: 60,
        ruleForm: {
          email:'',
          code:'',
          uid:'',
          pass: '',
          checkPass: '',
        },
        rules: {
          email: [
            { validator: validateemail, trigger: 'blur' }
          ],
          code: [
            { validator: validatecode, trigger: 'blur' }
          ],           
          uid: [
            { validator: validateuid, trigger: 'blur' }
          ],
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
        options: [{
          value: 'gmail.com',
          label: 'gmail.com'
        }, {
          value: 'icloud.com',
          label: 'icloud.com'
        }, {
          value: 'qq.com',
          label: 'qq.com'
        },{
          value: 'outlook.com',
          label: 'outlook.com'
        },{
          value: 'yahoo.com.tw',
          label: 'yahoo.com.tw'
        },{
          value: 'yahoo.com.my',
          label: 'yahoo.com.my'
        }, {
          value: 'live.hk',
          label: 'live.hk'
        }, {
          value: 'livemail.tw',
          label: 'livemail.tw'
        }, {
          value: 'live.com',
          label: 'live.com'
        }, {
          value: 'live.cn',
          label: 'live.cn'
        }, {
          value: 'hotmail.com',
          label: 'hotmail.com'
        },{
          value: 'yahoo.com',
          label: 'yahoo.com'
        }, {
          value: '126.com',
          label: '126.com'
        }],
        value: 'gmail.com',
      };
    },
    created() {
      //处理获取手机验证码倒计时
      const countdownStart = localStorage.getItem("countdownStart");
      const remainingTime = localStorage.getItem("remainingTime");
  
      if (countdownStart && remainingTime) {
          //计时开始时的时间到现在经过的时间
        const timePassed = (Date.now() - countdownStart) / 1000;
        const newRemainingTime = remainingTime - timePassed;
          // >0   计时没有结束  则更新剩余时间，继续计时
        if (newRemainingTime > 0) {
          this.long = Math.ceil(newRemainingTime);
          this.startCountdown();
        }
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
                this.$axios
                    .get("/Register.asp", {
                    params: {
                      uid:this.ruleForm.uid,
                      pass:this.ruleForm.pass,
                      checkPass:this.ruleForm.checkPass,
                      email:this.ruleForm.email+"@"+this.value,
                      code:this.ruleForm.code,
                    }
                    })
                    .then((res)=>{     
                      if(res.data.code == 205) {
                        this.$message({
                            message: "會員賬號已注冊過，老會員可尋回會員資料！",
                            type: "warning"
                        });
                        this.$router.push({path:'/recovery',query:{email:res.data.data}});
                      } else if(res.data.code != '200'){
                        this.$message({
                            message: res.data.data,
                            type: "error"
                        });
                      }else{
                        this.$router.push({path:'/success',query:{title:'注冊成功',msg:'恭喜閣下成功注冊了MOXGAME會員賬號，多謝支持！'}});                
                      }

                    })
                    .catch((error)=>{
                    this.$message({
                        message: "請求超時，請稍後再嘗試",
                        type: "error"
                    });
                });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      startCountdown() {
        this.codeDelay = true; // 禁用按钮
        this.timer = setInterval(() => {
          this.long--;
          //更新本地倒计时
          localStorage.setItem("remainingTime", this.long);
          if (this.long <= 0) {
            this.stopCountdown();
          }
        }, 1000);
      },

    stopCountdown() {
        clearInterval(this.timer); // 清除计时器
        this.codeDelay = false; // 重新启用按钮
        this.long = 60; // 重置倒计时时长
        localStorage.removeItem("countdownStart");
        localStorage.removeItem("remainingTime");
      },
      getCode() {

        this.$refs.ruleForm.validateField('email',(error) => {
          if (!error) {
                this.$axios
                    .get("/getMailCode.asp", {
                    params: {
                        email: this.ruleForm.email+"@"+this.value
                    }
                    })
                    .then((res)=>{
                      if(res.data.code == 205) {
                        this.$message({
                            message: "郵箱已注冊過，老會員可尋回會員資料！",
                            type: "warning"
                        });
                        this.$router.push({path:'/recovery',query:{email:res.data.data}});
                      }  else if(res.data.code != '200'){
                        this.$message({
                            message: res.data.data,
                            type: "error"
                        });
                      } else{
                        this.$message({
                            message: "發送成功，如未收到請檢查垃圾郵箱",
                            type: "success"
                        });        
                        localStorage.setItem("countdownStart", Date.now());
                        localStorage.setItem("remainingTime", this.long)
                        this.startCountdown()            
                      }

                    })
                    .catch((error)=>{
                    this.$message({
                        message: "請求超時，請稍後再嘗試",
                        type: "error"
                    });
                });
           }
        });
    },
    }
  }
</script>


 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a:link {color:#409EFF; text-decoration:none;} 
a:active{color:#409EFF; text-decoration:none;}
a:visited {color:#409EFF; text-decoration:none;}
a:hover {color:#409EFF; text-decoration:none;}
.app-container {
  display: block;
}
.games-container {
  max-width: 1281px;
  margin: auto;
}
.game-list-container {
  padding-bottom: 50px;
}
.games-title {
  margin-top: 20px;
  margin-left: 12px;
  font-size: 24px;
  font-family: Noto Sans KR, sans-serif;
  font-weight: 400;
  color: #000;
  opacity: 0.87;
  padding-bottom: 20px;
}
.game-form {
    max-width: 500px;
    margin:0 auto;
}
.el-button--primary {
    min-width:228px;
    min-height: 38px;
}

</style>


// WEBPACK FOOTER //
// src/components/Register.vue